import * as React from 'react';
import { cn } from '@/shared/lib/cn';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'field-glass flex min-h-[88px] w-full rounded-lg border border-input bg-[hsl(var(--glass-bg)/0.5)] px-3.5 py-2.5 shadow-glass-sm backdrop-blur-sm transition-[box-shadow,border-color,background-color] duration-200',
        'placeholder:text-muted-foreground/70',
        'focus-visible:border-primary/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
        /* 16px no mobile evita zoom automático do iOS ao focar o campo. */
        'text-[16px] sm:text-sm',
      )}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';
